// Knowledge kinds (specs/knowledge-kinds.md, #1368, #1369) — the `knowledgeKinds` namespace
// (Aineistot → Tietopohjat and Valmistelu → Tietopohja) and the `sourceTiers` namespace
// (the labels of AIReferences/tiers.js).

export const knowledgeKindsFi = {
  series: {
    newTitle: "Uusi tilastoaineisto",
    newLead: "Taulukkomuotoisia lukusarjoja (ennusteita, mittauksia) työpajan seinälle ja mittareille. Tuodaan siistinä taulukkona (.xlsx tai .csv): ulottuvuussarakkeet, jakso ja arvo, yksi havainto riviä kohden, sekä meta-lehti otsikolle, yksikölle, lähteelle ja lisenssille.",
    create: "Luo tilastoaineisto",
    back: "Takaisin tietopohjiin",
    tables: "Taulut",
    noTables: "Ei vielä tauluja. Lataa siisti taulukko alla.",
    uploadTitle: "Lataa taulukko",
    uploadLead: "Yksi .xlsx (lehti per taulu, meta-lehti) tai .csv (meta-rivit, sitten otsikkorivi). Sama avain korvaa aiemman taulun.",
    drop: "Pudota tiedosto tähän tai valitse",
    picked: "{{count}} tiedostoa valittu",
    upload: "Tuo taulut",
    added: "Tuotiin {{count}} taulua.",
    dimensions: "Ulottuvuudet",
    periods: "Jaksot",
    rows: "Havaintoja",
    source: "Lähde",
    imported: "Tuotu",
    file: "Tiedosto",
    remove: "Poista",
    removeConfirm: "Poistetaanko taulu \"{{title}}\" arvoineen?",
    tableCount: "{{tables}} taulua",
    openTables: "Avaa taulut",
  },
  kinds: {
    research: "Tutkimus",
    policy: "Linjaukset",
    opinion: "Mielipiteet",
    testimony: "Omat raportit",
    statistics: "Tilastot",
    kuutio: "Työpajan aineisto",
  },
  shapes: {
    text: "Lähdeaineistot",
    statements: "Mielipidekyselyt",
    series: "Tilastot",
  },
  all: "Kaikki",
  filterLabel: "Näytä",
  sourceKindsLead: "Jokaisen lähteen laji tunnistetaan, kun se lisätään, ja sen voi muuttaa ennen hyväksyntää. Tekoäly lukee tutkimuksen näyttönä, linjaukset kehyksenä ja mielipiteet mielipiteinä.",
  seriesTables: "{{tables}} taulua luettelossa",
  seriesNoCatalogue: "Luetteloa ei ole vielä haettu",
  importOpinion: "Tuo mielipideaineisto",
  panelLead: "Työpajan tekoäly lukee liitettyjen aineistojen lähteet lajinsa mukaan: tutkimuksen näyttönä, linjaukset kehyksenä, mielipiteet mielipiteinä ja omat raportit tekijöidensä kertomana.",
  tagging: {
    title: "Lähteiden lajit",
    lead: "{{untagged}} lähteellä ei ole vielä lajia, joten tekoäly lukee ne tutkimuksena. Tunnistus lukee kunkin lähteen alun ja ehdottaa lajin perusteluineen, samoin kuin uusille lähteille.",
    headersOnly: "{{headers}} lähteen tekstistä puuttuu sen laji. Se kirjoitetaan tekstiin ilman tekoälyä.",
    start: "Tunnista lajit",
    starting: "Aloitetaan…",
    stageTag: "Tunnistetaan lajeja: {{done}}/{{total}}",
    stageHeaders: "Kirjoitetaan lajit lähteiden tekstiin…",
    done: "Valmis: tutkimus {{research}}, linjaukset {{policy}}, mielipiteet {{opinion}}; ilman lajia {{unclassified}}, epäonnistui {{failed}}.",
  },
  // Aineistot → Tietopohjat → Indeksoitu komentoriviltä (#1382)
  cliDocs: {
    manageLead: "Tunnistus ehdotti lajit perusteluineen. Voit muuttaa lajin ja ottaa pois hausta dokumentin, joka ei ole oikea lähde.",
    kindOf: "Laji: {{title}}",
    byPerson: "Muutettu käsin",
    search: "Haku",
    exclude: "Pois hausta",
    include: "Takaisin hakuun",
  },
};

export const knowledgeKindsEn = {
  series: {
    newTitle: "New statistics dataset",
    newLead: "Tabular series of numbers (forecasts, measurements) for the workshop's wall and metrics. Imported as a tidy sheet (.xlsx or .csv): dimension columns, a period and a value, one observation per row, plus a meta sheet for the title, unit, source and licence.",
    create: "Create a statistics dataset",
    back: "Back to knowledge bases",
    tables: "Tables",
    noTables: "No tables yet. Upload a tidy sheet below.",
    uploadTitle: "Upload a sheet",
    uploadLead: "One .xlsx (a sheet per table, a meta sheet) or .csv (meta rows, then the header row). The same key replaces the earlier table.",
    drop: "Drop a file here or choose one",
    picked: "{{count}} files picked",
    upload: "Import tables",
    added: "Imported {{count}} tables.",
    dimensions: "Dimensions",
    periods: "Periods",
    rows: "Observations",
    source: "Source",
    imported: "Imported",
    file: "File",
    remove: "Remove",
    removeConfirm: "Remove the table \"{{title}}\" with its values?",
    tableCount: "{{tables}} tables",
    openTables: "Open the tables",
  },
  kinds: {
    research: "Research",
    policy: "Policy",
    opinion: "Opinion",
    testimony: "Own reports",
    statistics: "Statistics",
    kuutio: "Workshop material",
  },
  shapes: {
    text: "Source material",
    statements: "Opinion polls",
    series: "Statistics",
  },
  all: "All",
  filterLabel: "Show",
  sourceKindsLead: "Each source's kind is recognised when it is added, and can be changed before approval. The AI reads research as evidence, policy as framing and opinion as opinion.",
  seriesTables: "{{tables}} tables in the catalogue",
  seriesNoCatalogue: "The catalogue has not been fetched yet",
  importOpinion: "Import an opinion dataset",
  panelLead: "The workshop's AI reads the sources of the attached datasets by kind: research as evidence, policy as framing, opinion as opinion and own reports as their authors' account.",
  tagging: {
    title: "Kinds of source",
    lead: "{{untagged}} sources have no kind yet, so the AI reads them as research. Recognition reads the start of each source and proposes its kind with a reason, as it does for new sources.",
    headersOnly: "{{headers}} sources lack their kind in their text. It is written in without AI.",
    start: "Recognise kinds",
    starting: "Starting…",
    stageTag: "Recognising kinds: {{done}}/{{total}}",
    stageHeaders: "Writing the kinds into the sources' text…",
    done: "Done: research {{research}}, policy {{policy}}, opinion {{opinion}}; no kind {{unclassified}}, failed {{failed}}.",
  },
  cliDocs: {
    manageLead: "Recognition proposed the kinds with its reasons. You can change a kind, and take a document that is not a real source out of search.",
    kindOf: "Kind: {{title}}",
    byPerson: "Changed by hand",
    search: "Search",
    exclude: "Exclude from search",
    include: "Back into search",
  },
};

export const knowledgeKindsSv = {
  series: {
    newTitle: "Nytt statistikmaterial",
    newLead: "Talserier i tabellform (prognoser, mätningar) för verkstadens vägg och mätare. Importeras som en städad tabell (.xlsx eller .csv): dimensionskolumner, period och värde, en observation per rad, samt ett metablad för titel, enhet, källa och licens.",
    create: "Skapa statistikmaterial",
    back: "Tillbaka till kunskapsbaserna",
    tables: "Tabeller",
    noTables: "Inga tabeller ännu. Ladda upp en städad tabell nedan.",
    uploadTitle: "Ladda upp en tabell",
    uploadLead: "En .xlsx (ett blad per tabell, ett metablad) eller .csv (metarader, sedan rubrikraden). Samma nyckel ersätter den tidigare tabellen.",
    drop: "Släpp en fil här eller välj en",
    picked: "{{count}} filer valda",
    upload: "Importera tabeller",
    added: "Importerade {{count}} tabeller.",
    dimensions: "Dimensioner",
    periods: "Perioder",
    rows: "Observationer",
    source: "Källa",
    imported: "Importerad",
    file: "Fil",
    remove: "Ta bort",
    removeConfirm: "Ta bort tabellen \"{{title}}\" med dess värden?",
    tableCount: "{{tables}} tabeller",
    openTables: "Öppna tabellerna",
  },
  kinds: {
    research: "Forskning",
    policy: "Riktlinjer",
    opinion: "Opinioner",
    testimony: "Egna rapporter",
    statistics: "Statistik",
    kuutio: "Workshopmaterial",
  },
  shapes: {
    text: "Källmaterial",
    statements: "Opinionsmätningar",
    series: "Statistik",
  },
  all: "Alla",
  filterLabel: "Visa",
  sourceKindsLead: "Varje källas typ känns igen när den läggs till och kan ändras före godkännandet. AI:n läser forskning som belägg, riktlinjer som ram och opinioner som opinioner.",
  seriesTables: "{{tables}} tabeller i katalogen",
  seriesNoCatalogue: "Katalogen har inte hämtats ännu",
  importOpinion: "Importera opinionsdata",
  panelLead: "Workshopens AI läser källorna i de kopplade datamängderna efter typ: forskning som belägg, riktlinjer som ram, opinioner som opinioner och egna rapporter som författarnas redogörelse.",
  tagging: {
    title: "Källornas typer",
    lead: "{{untagged}} källor har ännu ingen typ, så AI:n läser dem som forskning. Igenkänningen läser början av varje källa och föreslår en typ med motivering, som för nya källor.",
    headersOnly: "{{headers}} källor saknar sin typ i texten. Den skrivs in utan AI.",
    start: "Känn igen typer",
    starting: "Startar…",
    stageTag: "Känner igen typer: {{done}}/{{total}}",
    stageHeaders: "Skriver in typerna i källornas text…",
    done: "Klart: forskning {{research}}, riktlinjer {{policy}}, opinioner {{opinion}}; utan typ {{unclassified}}, misslyckades {{failed}}.",
  },
  cliDocs: {
    manageLead: "Igenkänningen föreslog typerna med motiveringar. Du kan ändra en typ och ta bort ett dokument som inte är en riktig källa från sökningen.",
    kindOf: "Typ: {{title}}",
    byPerson: "Ändrad för hand",
    search: "Sökning",
    exclude: "Ta bort från sökningen",
    include: "Tillbaka till sökningen",
  },
};

export const sourceTiersFi = {
  rag: "Tutkimustieto",
  policy: "Linjaus",
  opinion: "Mielipide",
  testimony: "Oma raportti",
  api: "Avoin data",
  human: "Osallistujat",
  web: "Verkkohaku",
  policyDisclaimer: "Mitä on päätetty tai esitetty: kehys, ei näyttöä.",
  opinionDisclaimer: "Mitä ihmiset ajattelevat, ei tosiasia.",
  testimonyDisclaimer: "Mukana olleiden oma kertomus, ei riippumaton näyttö.",
  webDisclaimer: "Vinkkejä ja tuoretta tietoa; ei tarkistettu.",
};

export const sourceTiersEn = {
  rag: "Research",
  policy: "Policy",
  opinion: "Opinion",
  testimony: "Own report",
  api: "Open data",
  human: "Participants",
  web: "Web search",
  policyDisclaimer: "What has been decided or proposed: framing, not evidence.",
  opinionDisclaimer: "What people think, not fact.",
  testimonyDisclaimer: "The account of those involved, not independent evidence.",
  webDisclaimer: "Tips and fresh information; not checked.",
};

export const sourceTiersSv = {
  rag: "Forskning",
  policy: "Riktlinje",
  opinion: "Opinion",
  testimony: "Egen rapport",
  api: "Öppna data",
  human: "Deltagare",
  web: "Webbsökning",
  policyDisclaimer: "Vad som har beslutats eller föreslagits: en ram, inte belägg.",
  opinionDisclaimer: "Vad människor tycker, inte fakta.",
  testimonyDisclaimer: "De inblandades egen redogörelse, inte oberoende belägg.",
  webDisclaimer: "Tips och färsk information; inte kontrollerat.",
};
